import { defineStore } from "pinia";
import { api } from "../api/client.js";
import type { PublicUser } from "../api/types.js";

interface AuthState {
  user: PublicUser | null;
  /** True once the initial /api/auth/status check has resolved, so the router can wait for it. */
  ready: boolean;
}

export const useAuthStore = defineStore("auth", {
  state: (): AuthState => ({
    user: null,
    ready: false,
  }),
  getters: {
    isAuthenticated: (state) => state.user !== null,
    isAdmin: (state) => state.user?.isAdmin === true,
  },
  actions: {
    /** Checks the current session against the server. Safe to call repeatedly. */
    async refresh(): Promise<void> {
      try {
        const res = await api.get("/auth/status");
        this.user = res.data.authenticated ? res.data.user : null;
      } catch {
        this.user = null;
      } finally {
        this.ready = true;
      }
    },
    async login(email: string, password: string): Promise<void> {
      const res = await api.post("/auth/login", { email, password });
      this.user = res.data.user;
    },
    async logout(): Promise<void> {
      await api.post("/auth/logout");
      this.user = null;
    },
  },
});
